var map = {
	"./angular.png": 360,
	"./css.webp": 454,
	"./firebase.webp": 46,
	"./git.webp": 339,
	"./html.webp": 880,
	"./jest.png": 129,
	"./js.png": 565,
	"./npm.png": 277,
	"./react.webp": 994,
	"./sass.webp": 305,
	"./sc.png": 261,
	"./ts.png": 842,
	"./webpack.png": 384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 560;